export default __webpack_public_path__ + "static/bookinfo-off-mesh-83bfa62aed0ed5132b1970fa1917a109.webp";